import type { TUrlQuery } from './url.types.ts';

export const trimTrailingSlash = (url: string): string =>
  url.replace(/\/+$/, '');

export const buildQueryString = (query: TUrlQuery = {}): string => {
  const params = new URLSearchParams();

  for (const [name, value] of Object.entries(query)) {
    for (const item of Array.isArray(value) ? value : [value]) {
      if (item !== undefined) {
        params.append(name, String(item));
      }
    }
  }

  const encoded = params.toString();

  return encoded.length === 0 ? '' : `?${encoded}`;
};

export const buildUrl = (
  base: string,
  path: string,
  query?: TUrlQuery,
): string => {
  const encoded = buildQueryString(query);

  if (encoded.length === 0) {
    return `${base}${path}`;
  }

  return `${base}${path}${path.includes('?') ? `&${encoded.slice(1)}` : encoded}`;
};

export const removeUrlParams = (
  url: string,
  names: readonly string[],
): string => {
  const parsed = new URL(url);

  names.forEach((name) => parsed.searchParams.delete(name));

  return parsed.href;
};
